import { Component, OnInit, Input } from '@angular/core';
import { Book } from '../model/book.model';
import { BookService } from '../services/book.service';

@Component({
  selector: 'bs-book-list',
  templateUrl: './book-list.component.html',
  styleUrls: ['./book-list.component.css']
})
export class BookListComponent implements OnInit {
	private bookList :Book[] = [];

  	constructor(private bookService :BookService) {
  		
		}
		
		ngOnInit() { 
			this.bookList = this.bookService.getAll();
		}
	

		changePage(newPage :number) {
			console.log("[BookListComponent] New pagination page: ", newPage);
		}

 

}
